import axios from 'axios';
const config = require('../../server/config/index');

export default () => {
	return  axios.create({
		baseURL: config.EXTERNAL_BASE_URL,
		headers: {
			'X-Requested-With': 'XMLHttpRequest',
			'Access-Control-Allow-Origin': '*'
		}
	});
}
